import { render, staticRenderFns } from "./indexCopy1.vue?vue&type=template&id=1d2bc414&scoped=true"
import script from "./indexCopy1.vue?vue&type=script&lang=ts"
export * from "./indexCopy1.vue?vue&type=script&lang=ts"
import style0 from "./indexCopy1.vue?vue&type=style&index=0&id=1d2bc414&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2bc414",
  null
  
)

export default component.exports